/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory } from "react-router-dom"
import { TenkoDetailContext, TenkoKubunContext } from "../../context/context"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faIdCard, faTimes } from "@fortawesome/free-solid-svg-icons"
import { selectAlcoholCheckPage } from "../../../../constant/tablet/pages"
import { e点呼区分 } from "../../../../constant/enum/unko"

const SelectMenkyoUmu = () => {
  const history = useHistory()

  const { 点呼区分 } = useContext(TenkoKubunContext)
  const { 点呼明細, set点呼明細 } = useContext(TenkoDetailContext)

  const select免許 = (免許証フラグ: 0 | 1) => () => {
    set点呼明細({
      ...点呼明細,
      免許証フラグ: 免許証フラグ,
    })
    history.push(selectAlcoholCheckPage.Route.path)
  }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>免許証はありますか？</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={select免許(1)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon
                    style={{ marginRight: "2rem", color: "#0074be" }}
                    icon={faIdCard}
                  />
                  <span>免許証 有</span>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={select免許(0)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <div
                    className="d-inline-block"
                    style={{ position: "relative" }}>
                    <FontAwesomeIcon
                      style={{ marginRight: "2rem" }}
                      icon={faIdCard}
                    />
                    <FontAwesomeIcon
                      style={{
                        color: CSS_PROPERTY.WARN_COLOR,
                        fontSize: "4rem",
                        position: "absolute",
                        top: "-1rem",
                        left: "-1rem",
                      }}
                      icon={faTimes}
                    />
                  </div>
                  <span>免許証 無</span>
                </div>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              {/* 終業点呼でここに来た場合、登録後の関係上、前のページに戻るのは不都合があるためボタンを表示しない */}
              {[e点呼区分.終業点呼, e点呼区分.終業点呼2].find(
                (コード) => コード === 点呼区分?.区分コード
              ) == null && <BackButton />}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectMenkyoUmu
